
<template>
<div class=" card card-custom bg-white border-white border-0">
<div class="card-custom-img">
  <div
      class="card-custom-img"
      :style="{'background-image': `url(${img})` }"
  >

  </div>
</div>
  <slot name="p-1" ></slot>

  <slot name="p-2"></slot>

  <div class="card-footer">

    <slot name="p-3"></slot>

  </div>
</div>
</template>

<script>
export default {
name: "Card11",
  props: {
    img: {
      default: "https://picsum.photos/id/237/200/300"
    },
  },
}
</script>

<style scoped>
.card-custom {
  overflow: hidden;
  min-height: 100%;
  box-shadow: 0 0 15px rgba(10, 10, 10, 0.3);
}
.card-custom-img {
  height: 300px;
  min-height: 200px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-color: inherit;
}
.card-custom-img::after {
  position: absolute;
  content: "";
  top: 261px;
  transform: rotateY(180deg);
  right: -1px;
  width: 0;
  height: 0;
  border-style: solid;
  border-top-width: 40px;
  border-right-width: 0;
  border-bottom-width: 0;
  border-left-width: calc(575px - 5vw);
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: inherit;
}
.card-custom-avatar img {
  border-radius: 50%;
  box-shadow: 0 0 15px rgba(10, 10, 10, 0.3);
  position: absolute;
  top: 100px;
  right: 1.25rem;
  width: 100px;
  height: 100px;
}
</style>
